// Module
var code = `<div class="form-section-field">
  <div ng-class="{'form-section-auto-width-title': \$ctrl.autoWidthTitle,
                  'form-section-fixed-width-title': !\$ctrl.autoWidthTitle}"
                  class="form-section-field-title">{{\$ctrl.fieldTitle}}</div>
	<div class="form-section-field-input"
       ng-class="{'form-section-field-input__fit-content': \$ctrl.fitContent}"
       ng-transclude>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/form-section/form-section-field.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;